import {Injectable} from '@angular/core';
import {ActivityAuditClient, PagedListOfActivityAuditViewModel} from './api.client';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';

@Injectable()
export class ActivityAuditService {
    constructor(private _activityAuditClient: ActivityAuditClient) {
    }

    searchActivityAudits(
        id: string,
        sortName: string,
        descending: boolean,
        limit: number,
        offset: number
    ): Observable<PagedListOfActivityAuditViewModel> {
        return this._activityAuditClient.searchAssistanceApplicationActivityAudits(
            id,
            sortName,
            null,
            descending,
            limit || 10,
            offset || 0
        ).pipe(share());
    }
}
